import e from"./_defineProperty.js";var r=e;var a=function(e,a,o){"__proto__"==a&&r?r(e,a,{configurable:!0,enumerable:!0,value:o,writable:!0}):e[a]=o};export{a as default};
//# sourceMappingURL=_baseAssignValue.js.map
